import { Card, Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { ModuleType, VehicleKind } from '../../../../api/types';
import ModuleSelectField from '../../../../components/fields/ModuleSelectField';
import VehicleSelectField from '../../../../components/fields/VehicleSelectField';
import { type ModelConfiguratorFormValues } from './utils';

const ModelConfiguratorSetupForm = () => {
    const { t } = useTranslation(['modelConfiguratorDetails']);

    const { values } = useFormikContext<ModelConfiguratorFormValues>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            moduleId: values?.moduleId,
        },
        skip: !values?.moduleId,
    });

    const vehicleModuleId =
        data?.module?.__typename === ModuleType.ConfiguratorModule ? data?.module?.vehicleModuleId : null;

    return (
        <Card title={t('modelConfiguratorDetails:sections.setup')}>
            <Row gutter={14}>
                <Col lg={8} xs={24}>
                    <ModuleSelectField
                        {...t('modelConfiguratorDetails:fields.moduleName', { returnObjects: true })}
                        moduleType={ModuleType.ConfiguratorModule}
                        name="moduleId"
                        required
                    />
                </Col>
                <Col lg={8} xs={24}>
                    <VehicleSelectField
                        {...t('modelConfiguratorDetails:fields.model', { returnObjects: true })}
                        disabled={!values?.moduleId}
                        loading={loading}
                        moduleId={vehicleModuleId}
                        name="modelId"
                        vehicleKind={VehicleKind.LocalModel}
                        required
                        showSearch
                        useSuiteId
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default ModelConfiguratorSetupForm;
